/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AtkomstNodeDto
 */
export interface AtkomstNodeDto {
    /**
     * Node identifier (e.g. STO.468, CTY.SE)
     * @type {string}
     * @memberof AtkomstNodeDto
     */
    nodeId: string;
    /**
     * Node type (e.g. STO, CTY)
     * @type {string}
     * @memberof AtkomstNodeDto
     */
    nodeType: string;
    /**
     * Node name
     * @type {string}
     * @memberof AtkomstNodeDto
     */
    name?: string;
}

/**
 * Check if a given object implements the AtkomstNodeDto interface.
 */
export function instanceOfAtkomstNodeDto(value: object): boolean {
    if (!('nodeId' in value)) return false;
    if (!('nodeType' in value)) return false;
    return true;
}

export function AtkomstNodeDtoFromJSON(json: any): AtkomstNodeDto {
    return AtkomstNodeDtoFromJSONTyped(json, false);
}

export function AtkomstNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtkomstNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nodeId': json['nodeId'],
        'nodeType': json['nodeType'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AtkomstNodeDtoToJSON(value?: AtkomstNodeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nodeId': value['nodeId'],
        'nodeType': value['nodeType'],
        'name': value['name'],
    };
}

